import Api from "@/services/Api";

export async function getSiteMap () {
    const response = await Api().get("sitemap");

    return response.data;
}